import ReactDOMServer from 'react-dom/server';
import classNames from 'classnames';

/*************************
 * Start Debugging
 *
 * Step 1. Change debug variable to true.
 * Step 2. Uncomment debug function inside of the getHeight function
 * Step 3. Set index to row you want to debug
 */

// eslint-disable-next-line no-unused-vars
const debug = false;
const innerWrapper = document.createElement('div');
innerWrapper.className = classNames(
  'featured-fullscreen-editor',
  'featured-editor',
);

const midWrapper = document.createElement('div');
midWrapper.className = classNames(
  'featured-fullscreen-editor-wrapper',
  'featured-editor-wrapper',
);
midWrapper.appendChild(innerWrapper);

const outerWrapper = document.createElement('div');
outerWrapper.className = classNames(
  'show-wrapper',
  'show-featured-wrapper',
  'fullscreen',
);
outerWrapper.appendChild(midWrapper);

const heightHelperContainer = document.createElement('div');
heightHelperContainer.id = 'prompterHeightHelperContainer';
heightHelperContainer.style.position = 'fixed';
heightHelperContainer.style.visibility = 'hidden';
heightHelperContainer.style.left = '-3000px';
heightHelperContainer.appendChild(outerWrapper);

document.body.appendChild(heightHelperContainer);

export default {
  // eslint-disable-next-line
  getRowHeight(rowElement, width, index) {
    midWrapper.style.width = `${width}px`;
    const htmlString = ReactDOMServer.renderToStaticMarkup(rowElement);
    innerWrapper.innerHTML = htmlString;
    const height = _getMockHeight(innerWrapper);
    /*
    if (debug) {
      // set index of row you want to debug
      if (index === 0) {
        let debugNode = heightHelperContainer.cloneNode(true);
        debugNode.style.left = '0px';
        debugNode.style.visibility = null;
        document.body.appendChild(debugNode);
      }
    }
    */
    return height;
  },
};

function _getMockHeight(el) {
  return Math.max(el.scrollHeight, el.offsetHeight);
}
